(() => {
  if (window.lplPdpAccordionsBound) return;
  window.lplPdpAccordionsBound = true;
  const selector = 'details[data-lpl-pdp-accordion]';
  const syncExpanded = (details) => {
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
  };

  // Native details[name] handles exclusivity without JS in supporting browsers.
  // Capture toggle for older browsers, dynamic section swaps, and Dawn's ARIA.
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details.matches?.(selector)) return;
    const product = details.closest('product-info');
    if (details.open && product) {
      product.querySelectorAll(selector).forEach((sibling) => {
        if (sibling !== details && sibling.open) {
          sibling.open = false;
          syncExpanded(sibling);
        }
      });
    }
    syncExpanded(details);
  }, true);
})();
